import {
  FIRST_VISIT_SPLASH_EXCLUDED_PATHS,
  DEFAULT_WELCOME_SCREEN_SECONDS,
  MIN_WELCOME_SCREEN_SECONDS,
  MAX_WELCOME_SCREEN_SECONDS,
} from '../constants/bookingConst';
import { isUnderRoute } from './routeUtil';

/**
 * Whether a path is one that skips the welcome (the Point of Sale).
 *
 * @param {string} pathname - e.g. window.location.pathname
 * @returns {boolean}
 */
export const isSplashExcludedPath = (pathname = '') => isUnderRoute(pathname, FIRST_VISIT_SPLASH_EXCLUDED_PATHS);

/**
 * Whether this page load opens with the welcome: every load of a guest page
 * or the admin dashboard — first visit, refresh or return visit alike.
 *
 * @param {string} pathname - e.g. window.location.pathname
 * @returns {boolean}
 */
export const shouldShowFirstVisitSplash = (pathname) => !isSplashExcludedPath(pathname);

/**
 * Brings a welcome duration into its allowed range. Blank or non-numeric
 * input falls back to the default rather than to NaN.
 *
 * @param {unknown} value - seconds, as a number or a string from .env
 * @returns {number} whole seconds within [MIN_, MAX_WELCOME_SCREEN_SECONDS]
 */
export const clampWelcomeScreenSeconds = (value) => {
  const parsed = parseInt(value, 10);
  if (!Number.isFinite(parsed)) return DEFAULT_WELCOME_SCREEN_SECONDS;
  return Math.min(Math.max(parsed, MIN_WELCOME_SCREEN_SECONDS), MAX_WELCOME_SCREEN_SECONDS);
};

/**
 * How long the welcome stays up: REACT_APP_WELCOME_SCREEN_SECONDS from
 * .env.common (shared by every client), clamped, or the default when unset.
 * Create React App inlines REACT_APP_* values at build time, so a change
 * takes effect on the next build/deploy.
 *
 * @returns {number} milliseconds
 */
export const getWelcomeScreenDurationMs = () => (
  clampWelcomeScreenSeconds(process.env.REACT_APP_WELCOME_SCREEN_SECONDS) * 1000
);
